export default {
      id: "about-icon-4-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#about-icon-4",
      toString: function () {
        return this.url;
      }
    }